import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

export const outputApi = createApi({
  reducerPath: "outputApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL}/v2`,
  }),
  tagTypes: ["OutputFiles"],
  endpoints: (builder) => ({
    // List Output Files
    getOutputFiles: builder.query({
      query: (token) => `${token}/output/index`,
      providesTags: ["OutputFiles"],
    }),

    // Download Output File
    downloadOutputFile: builder.query({
      query: ({ token, filename }) => `${token}/output/${filename}`,
      responseHandler: (response) => response.blob(),
    }),

    // Delete Output File
    deleteOutputFile: builder.mutation({
      query: ({ token, filename }) => ({
        url: `${token}/output/${filename}`,
        method: "DELETE",
      }),
      invalidatesTags: ["OutputFiles"],
    }),
  }),
});

export const {
  useGetOutputFilesQuery,
  useDownloadOutputFileQuery,
  useDeleteOutputFileMutation,
} = outputApi;

export default outputApi;
